import styled from "styled-components";

const Wrapper = styled.div`
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  padding-right: 8px;
  padding-left: 8px;

  // padding-right: 16px;
  // padding-left: 16px;
  width: 100%;
  max-width: 100%;

  @media only screen and (min-width: 576px) {
    width: 560px;
    max-width: 100%;
  }

  @media only screen and (min-width: 768px) {
    width: 752px;
    max-width: 100%;
  }

  @media only screen and (min-width: 992px) {
    width: 976px;
    max-width: 100%;
  }

  @media only screen and (min-width: 1200px) {
    width: 1184px;
    max-width: 100%;
  }
`;

export const WrapperGrid = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};
